import {
  LOAD_CONTACT,
  RECIEVE_CONTACTS,
  REQUEST_CONTACTS,
  SEARCH_CONTACTS_BY_STRING,
  SORT_CONTACTS_BY_KEY,
} from '../actions';

import { makeIdToContactMap } from '../utils/contacts.jsx';
import Immutable from 'immutable';

const defaultState = Immutable.fromJS({
  isFetching: false,
  items: [],
  currentContact: {},
  sortKey: 'full_name',
  searchString: '',
  lastUpdated: 0,
});

export function contacts(state = defaultState, action = null) {
  switch (action.type) {
    case REQUEST_CONTACTS: {
      return state.set('isFetching', true);
    }
    case RECIEVE_CONTACTS: {
      return state.withMutations(state => {
        state
          .set('isFetching', false)
          .set('items', action.contacts)
          .set('lastUpdated', action.receivedAt);
      });
    }
    case SORT_CONTACTS_BY_KEY: {
      return state.set('sortKey', action.sortKey);
    }
    case SEARCH_CONTACTS_BY_STRING: {
      return state.set('searchString', action.searchString);
    }
    case LOAD_CONTACT: {
      return state.withMutations(state => {
        state.set(
          'currentContact',
          makeIdToContactMap(state.get('items')).get(
            parseInt(action.contactId, 10),
            action.fallbackProfile
          )
        );
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/contacts.js